import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  invalidTrailingComma2uwwnmbqspks2 as invalidTrailingComma,
  minify1kh64osmcox7j as minify,
  access$formatDecodingException$tJsonExceptionsKt2yfifxvnjk03f as access$formatDecodingException$tJsonExceptionsKt,
  throwInvalidFloatingPointDecoded3ghwdo6vya1kj as throwInvalidFloatingPointDecoded,
} from './JsonExceptions.mjs';
import {
  getJsonNameIndex1fee1p51fy8fj as getJsonNameIndex,
  ignoreUnknownKeys1ot1okvsp9ttf as ignoreUnknownKeys,
  getJsonNameIndexOrThrow1a6a29i1xie0m as getJsonNameIndexOrThrow,
} from './JsonNamesMap.mjs';
import { ENUM_getInstance25239ht7oag6o as ENUM_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { AbstractDecoder35guh02ubh2hm as AbstractDecoder } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/encoding/AbstractDecoder.mjs';
import { JsonElementMarker395jk2pil4789 as JsonElementMarker } from './JsonElementMarker.mjs';
import { JsonTreeReader1ycreu77eikqj as JsonTreeReader } from './JsonTreeReader.mjs';
import { AbstractPolymorphicSerializer1ccxwp48nfy58 as AbstractPolymorphicSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/AbstractPolymorphicSerializer.mjs';
import {
  classDiscriminator9fd3hvqsgfqq as classDiscriminator,
  subtypeNotRegisteredMessageJson3mtuvvd9idjxz as subtypeNotRegisteredMessageJson,
} from './JsonPolymorphicHelpers.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { DeserializationStrategy1z3z5pj9f7zc8 as DeserializationStrategy } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  JsonObjectee06ihoeeiqj as JsonObject,
  get_jsonPrimitivez17tyd5rw1ql as get_jsonPrimitive,
  get_contentOrNull35s97cgi8z9eo as get_contentOrNull,
} from '../JsonElement.mjs';
import {
  getKClass3t8tygqu4lcxf as getKClass,
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { JsonDecodingExceptionoyag1psadwuw as JsonDecodingException } from '../JsonExceptions.mjs';
import { readPolymorphicJson7wfdzotvo8aj as readPolymorphicJson } from './TreeJsonDecoder.mjs';
import {
  Exceptiondt2hlxn7j7vw as Exception,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  SerializationExceptioneqrdve3ts2n9 as SerializationException,
  MissingFieldException24tqif29emcmi as MissingFieldException,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { contains3ue2qo8xhmpf1 as contains } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { plus17rl43at52ays as plus } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { missingFieldExceptionWithNewMessage2gqddjx5jxge9 as missingFieldExceptionWithNewMessage } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/JsonInternalDependencies.mjs';
import {
  modeFort67zb8ch2jog as modeFor,
  LexerMode_MAP_getInstance2xhiu8e07rxc7 as LexerMode_MAP_getInstance,
} from './LexerMode.mjs';
import {
  convertToByte2t4hntblnhq2k as convertToByte,
  fromInt2ii0rejb1w62w as fromInt,
  convertToShortn6n5n7ruahkm as convertToShort,
  convertToInty04h231mmjoh as convertToInt,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { toDouble1kn912gjoizjp as toDouble } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import {
  isFinite1tx0gn65nl9tj as isFinite,
  isFinite2t9l5a275mxm6 as isFinite_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/NumbersJs.mjs';
import { charCodeAt1yspne1d8erbm as charCodeAt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { get_isUnsignedNumber3dxwaa3af8ncr as get_isUnsignedNumber } from './StreamingJsonEncoder.mjs';
import { JsonDecoder1rijst5ne6qla as JsonDecoder } from '../JsonDecoder.mjs';
import {
  toUInt21lx0mz8wkp7c as toUInt,
  toULong266mnyksbttkw as toULong,
  toUByteh6p4wmqswkrs as toUByte,
  toUShort7yqspfnhrot4 as toUShort,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/UStrings.mjs';
import { _UInt___get_data__impl__f0vqqw30ojw38w2y6td as _UInt___get_data__impl__f0vqqw } from '../../../../../kotlin-kotlin-stdlib/kotlin/UInt.mjs';
import { _ULong___get_data__impl__fggpzbbo8lz7f8fnfy as _ULong___get_data__impl__fggpzb } from '../../../../../kotlin-kotlin-stdlib/kotlin/ULong.mjs';
import { _UByte___get_data__impl__jof9qr100nrznmlnqj as _UByte___get_data__impl__jof9qr } from '../../../../../kotlin-kotlin-stdlib/kotlin/UByte.mjs';
import { _UShort___get_data__impl__g02451raj6q6epxg1b as _UShort___get_data__impl__g0245 } from '../../../../../kotlin-kotlin-stdlib/kotlin/UShort.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DiscriminatorHolderClass;
function DiscriminatorHolder() {
  if (DiscriminatorHolderClass === VOID) {
    class $ {
      constructor(discriminatorToSkip) {
        this.j2w_1 = discriminatorToSkip;
      }
    }
    initMetadataForClass($, 'DiscriminatorHolder');
    DiscriminatorHolderClass = $;
  }
  return DiscriminatorHolderClass;
}
function trySkip($this, $receiver, unknownKey) {
  if ($receiver == null)
    return false;
  if ($receiver.j2w_1 === unknownKey) {
    $receiver.j2w_1 = null;
    return true;
  }
  return false;
}
function skipLeftoverElements($this, descriptor) {
  while (!($this.j1s(descriptor) === -1)) {
  }
}
function checkLeadingComma($this) {
  if ($this.p2o_1.x2v() === 4) {
    $this.p2o_1.o2u('Unexpected leading comma');
  }
}
function decodeMapIndex($this) {
  var hasComma = false;
  var decodingKey = !(($this.r2o_1 % 2 | 0) === 0);
  if (decodingKey) {
    if (!($this.r2o_1 === -1)) {
      hasComma = $this.p2o_1.l2w();
    }
  } else {
    $this.p2o_1.k2w(_Char___init__impl__6a9atx(58));
  }
  var tmp;
  if ($this.p2o_1.y2v()) {
    if (decodingKey) {
      if ($this.r2o_1 === -1) {
        var tmp0 = $this.p2o_1;
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
        var condition = !hasComma;
        var position = tmp0.w2o_1;
        if (!condition) {
          var tmp$ret$1 = 'Unexpected leading comma';
          tmp0.o2u(tmp$ret$1, position);
        }
      } else {
        var tmp0_0 = $this.p2o_1;
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
        var condition_0 = hasComma;
        var position_0 = tmp0_0.w2o_1;
        if (!condition_0) {
          var tmp$ret$3 = 'Expected comma after the key-value pair';
          tmp0_0.o2u(tmp$ret$3, position_0);
        }
      }
    }
    $this.r2o_1 = $this.r2o_1 + 1 | 0;
    tmp = $this.r2o_1;
  } else {
    if (hasComma && !$this.n2o_1.i2o_1.k2q_1) {
      invalidTrailingComma($this.p2o_1);
    }
    tmp = -1;
  }
  return tmp;
}
function coerceInputValue($this, descriptor, index) {
  var tmp0 = $this.n2o_1;
  var tmp$ret$0;
  $l$block_2: {
    // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue' call
    var isOptional = descriptor.f1q(index);
    var elementDescriptor = descriptor.e1q(index);
    var tmp;
    if (isOptional && !elementDescriptor.q1p()) {
      tmp = $this.p2o_1.m2w(true);
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = true;
      break $l$block_2;
    }
    if (equals(elementDescriptor.x1p(), ENUM_getInstance())) {
      var tmp_0;
      if (elementDescriptor.q1p()) {
        tmp_0 = $this.p2o_1.m2w(false);
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$0 = false;
        break $l$block_2;
      }
      var tmp0_elvis_lhs = $this.p2o_1.n2w($this.t2o_1.y2p_1);
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$0 = false;
        break $l$block_2;
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      var enumValue = tmp_1;
      var enumIndex = getJsonNameIndex(elementDescriptor, tmp0, enumValue);
      var coerceToNull = !tmp0.i2o_1.b2q_1 && elementDescriptor.q1p();
      if (enumIndex === -3 && (isOptional || coerceToNull)) {
        $this.p2o_1.z2v();
        tmp$ret$0 = true;
        break $l$block_2;
      }
    }
    tmp$ret$0 = false;
  }
  return tmp$ret$0;
}
function decodeObjectIndex($this, descriptor) {
  var hasComma = $this.p2o_1.l2w();
  while ($this.p2o_1.y2v()) {
    hasComma = false;
    var key = decodeStringKey($this);
    $this.p2o_1.k2w(_Char___init__impl__6a9atx(58));
    var index = getJsonNameIndex(descriptor, $this.n2o_1, key);
    var tmp;
    if (!(index === -3)) {
      var tmp_0;
      if ($this.t2o_1.d2q_1 && coerceInputValue($this, descriptor, index)) {
        hasComma = $this.p2o_1.l2w();
        tmp_0 = false;
      } else {
        var tmp0_safe_receiver = $this.u2o_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.l2u(index);
        }
        return index;
      }
      tmp = tmp_0;
    } else {
      tmp = true;
    }
    var isUnknown = tmp;
    if (isUnknown) {
      hasComma = handleUnknown($this, descriptor, key);
    }
  }
  if (hasComma && !$this.n2o_1.i2o_1.k2q_1) {
    invalidTrailingComma($this.p2o_1);
  }
  var tmp1_safe_receiver = $this.u2o_1;
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.m2u();
  return tmp2_elvis_lhs == null ? -1 : tmp2_elvis_lhs;
}
function handleUnknown($this, descriptor, key) {
  if (ignoreUnknownKeys(descriptor, $this.n2o_1) || trySkip($this, $this.s2o_1, key)) {
    $this.p2o_1.p2w($this.t2o_1.y2p_1);
  } else {
    $this.p2o_1.x2o_1.c2v();
    $this.p2o_1.o2w(key);
  }
  return $this.p2o_1.l2w();
}
function decodeListIndex($this) {
  var hasComma = $this.p2o_1.l2w();
  var tmp;
  if ($this.p2o_1.y2v()) {
    if (!($this.r2o_1 === -1) && !hasComma) {
      $this.p2o_1.o2u('Expected end of the array or comma');
    }
    $this.r2o_1 = $this.r2o_1 + 1 | 0;
    tmp = $this.r2o_1;
  } else {
    if (hasComma && !$this.n2o_1.i2o_1.k2q_1) {
      invalidTrailingComma($this.p2o_1, 'array');
    }
    tmp = -1;
  }
  return tmp;
}
function decodeStringKey($this) {
  var tmp;
  if ($this.t2o_1.y2p_1) {
    tmp = $this.p2o_1.r2w();
  } else {
    tmp = $this.p2o_1.q2w();
  }
  return tmp;
}
var StreamingJsonDecoderClass;
function StreamingJsonDecoder() {
  if (StreamingJsonDecoderClass === VOID) {
    class $ extends AbstractDecoder() {
      constructor(json, mode, lexer, descriptor, discriminatorHolder) {
        super();
        this.n2o_1 = json;
        this.o2o_1 = mode;
        this.p2o_1 = lexer;
        this.q2o_1 = this.n2o_1.h1s();
        this.r2o_1 = -1;
        this.s2o_1 = discriminatorHolder;
        this.t2o_1 = this.n2o_1.i2o_1;
        this.u2o_1 = this.t2o_1.b2q_1 ? null : new (JsonElementMarker())(descriptor);
      }
      p2q() {
        return this.n2o_1;
      }
      h1s() {
        return this.q2o_1;
      }
      q2q() {
        return (new (JsonTreeReader())(this.n2o_1.i2o_1, this.p2o_1)).b2w();
      }
      r1r(deserializer) {
        var tmp2_withExceptionHandling_this = this.p2o_1.x2o_1;
        var tmp3_withExceptionHandling_this = this.p2o_1;
        // Inline function 'kotlinx.serialization.json.internal.withExceptionHandling' call
        var tmp;
        try {
          var tmp_0;
          if (!(deserializer instanceof AbstractPolymorphicSerializer())) {
            tmp_0 = true;
          } else {
            tmp_0 = this.n2o_1.i2o_1.e2q_1;
          }
          if (tmp_0) {
            return deserializer.d1n(this);
          }
          var discriminator = classDiscriminator(deserializer.b1n(), this.n2o_1);
          var tmp0_elvis_lhs = this.p2o_1.s2w(discriminator, this.t2o_1.y2p_1);
          var tmp_1;
          if (tmp0_elvis_lhs == null) {
            var tmp2 = isInterface(deserializer, DeserializationStrategy()) ? deserializer : THROW_CCE();
            var tmp$ret$2;
            $l$block: {
              // Inline function 'kotlinx.serialization.json.internal.decodeSerializableValuePolymorphic' call
              var tmp_2;
              if (!(tmp2 instanceof AbstractPolymorphicSerializer())) {
                tmp_2 = true;
              } else {
                tmp_2 = this.p2q().i2o_1.e2q_1;
              }
              if (tmp_2) {
                tmp$ret$2 = tmp2.d1n(this);
                break $l$block;
              }
              var discriminator_0 = classDiscriminator(tmp2.b1n(), this.p2q());
              var tmp2_0 = this.q2q();
              // Inline function 'kotlinx.serialization.json.internal.cast' call
              var serialName = tmp2.b1n().e1o();
              if (!(tmp2_0 instanceof JsonObject())) {
                var tmp2_1 = 'Expected ' + getKClass(JsonObject()).j1() + ', but had ' + getKClassFromExpression(tmp2_0).j1() + ' as the serialized body of ' + serialName;
                // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
                var path = this.p2o_1.x2o_1.d2v();
                var tmp_3;
                if (this.p2q().i2o_1.n2q_1) {
                  var tmp$ret$8 = toString(tmp2_0);
                  tmp_3 = toString(minify(tmp$ret$8));
                } else {
                  tmp_3 = null;
                }
                var inputValue = tmp_3;
                throw JsonDecodingException().i2s(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2_1, path, null, inputValue), tmp2_1, -1, path, inputValue, null);
              }
              var jsonTree = tmp2_0;
              var tmp0_safe_receiver = jsonTree.t2q(discriminator_0);
              var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_jsonPrimitive(tmp0_safe_receiver);
              var type = tmp1_safe_receiver == null ? null : get_contentOrNull(tmp1_safe_receiver);
              var tmp_4 = tmp2.u1n(this, type);
              var actualSerializer = (!(tmp_4 == null) ? isInterface(tmp_4, DeserializationStrategy()) : false) ? tmp_4 : null;
              if (actualSerializer == null) {
                var _destruct__k2r9zo = subtypeNotRegisteredMessageJson(type, tmp2.s1n());
                var message = _destruct__k2r9zo.df();
                var hint = _destruct__k2r9zo.ef();
                // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
                var path_0 = this.p2o_1.x2o_1.d2v();
                var tmp_5;
                if (this.p2q().i2o_1.n2q_1) {
                  var tmp$ret$13 = jsonTree.toString();
                  tmp_5 = toString(minify(tmp$ret$13));
                } else {
                  tmp_5 = null;
                }
                var inputValue_0 = tmp_5;
                throw JsonDecodingException().i2s(access$formatDecodingException$tJsonExceptionsKt(-1, message, path_0, hint, inputValue_0), message, -1, path_0, inputValue_0, hint);
              }
              tmp$ret$2 = readPolymorphicJson(this.p2q(), discriminator_0, jsonTree, actualSerializer);
            }
            return tmp$ret$2;
          } else {
            tmp_1 = tmp0_elvis_lhs;
          }
          var type_0 = tmp_1;
          var tmp_6 = deserializer.u1n(this, type_0);
          var actualSerializer_0 = (!(tmp_6 == null) ? isInterface(tmp_6, DeserializationStrategy()) : false) ? tmp_6 : null;
          if (actualSerializer_0 == null) {
            var _destruct__k2r9zo_0 = subtypeNotRegisteredMessageJson(type_0, deserializer.s1n());
            var message_0 = _destruct__k2r9zo_0.df();
            var hint_0 = _destruct__k2r9zo_0.ef();
            this.p2o_1.o2u(message_0, VOID, hint_0);
          }
          this.s2o_1 = new (DiscriminatorHolder())(discriminator);
          tmp = actualSerializer_0.d1n(this);
        } catch ($p) {
          var tmp_7;
          if ($p instanceof MissingFieldException()) {
            var e = $p;
            if (contains(ensureNotNull(e.message), 'at path'))
              throw e;
            var tmp_8 = plus(e.message, ' at path: ');
            var tmp$ret$14 = tmp2_withExceptionHandling_this.d2v();
            throw missingFieldExceptionWithNewMessage(e, tmp_8 + tmp$ret$14);
          } else {
            if ($p instanceof SerializationException()) {
              var e_0 = $p;
              throw e_0;
            } else {
              if ($p instanceof Exception()) {
                var e_1 = $p;
                // Inline function 'kotlinx.serialization.json.internal.errorFromDeserializer' call
                var path_1 = tmp2_withExceptionHandling_this.d2v();
                var causeMessage = e_1.message;
                var shortMessage = 'Deserialization failed because of ' + (causeMessage == null ? 'an exception' : "'" + causeMessage + "' exception") + ' in the decoder';
                var tmp_9;
                if (this.p2q().i2o_1.n2q_1) {
                  var tmp$ret$19 = tmp3_withExceptionHandling_this.t2w();
                  tmp_9 = toString(minify(tmp$ret$19));
                } else {
                  tmp_9 = null;
                }
                var inputValue_1 = tmp_9;
                throw JsonDecodingException().i2s(access$formatDecodingException$tJsonExceptionsKt(-1, shortMessage, path_1, null, inputValue_1), shortMessage, -1, path_1, inputValue_1, null, e_1);
              } else {
                throw $p;
              }
            }
          }
        }
        return tmp;
      }
      s1r(descriptor) {
        var newMode = modeFor(this.n2o_1, descriptor);
        this.p2o_1.x2o_1.y2u(descriptor);
        this.p2o_1.k2w(newMode.f2w_1);
        checkLeadingComma(this);
        var tmp;
        switch (newMode.w1_1) {
          case 1:
          case 2:
          case 3:
            tmp = new (StreamingJsonDecoder())(this.n2o_1, newMode, this.p2o_1, descriptor, this.s2o_1);
            break;
          default:
            var tmp_0;
            if (this.o2o_1.equals(newMode) && this.n2o_1.i2o_1.b2q_1) {
              tmp_0 = this;
            } else {
              tmp_0 = new (StreamingJsonDecoder())(this.n2o_1, newMode, this.p2o_1, descriptor, this.s2o_1);
            }

            tmp = tmp_0;
            break;
        }
        return tmp;
      }
      t1r(descriptor) {
        if (descriptor.z1p() === 0 && ignoreUnknownKeys(descriptor, this.n2o_1)) {
          skipLeftoverElements(this, descriptor);
        }
        if (this.p2o_1.l2w() && !this.n2o_1.i2o_1.k2q_1) {
          invalidTrailingComma(this.p2o_1, '');
        }
        this.p2o_1.k2w(this.o2o_1.g2w_1);
        this.p2o_1.x2o_1.c2v();
      }
      d1r() {
        var tmp;
        var tmp0_safe_receiver = this.u2o_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k2u_1;
        if (!(tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs)) {
          tmp = !this.p2o_1.u2w();
        } else {
          tmp = false;
        }
        return tmp;
      }
      e1r() {
        return null;
      }
      e1s(descriptor, index, deserializer, previousValue) {
        var isMapKey = this.o2o_1.equals(LexerMode_MAP_getInstance()) && (index & 1) === 0;
        if (isMapKey) {
          this.p2o_1.x2o_1.b2v();
        }
        var value = super.e1s(descriptor, index, deserializer, previousValue);
        if (isMapKey) {
          this.p2o_1.x2o_1.a2v(value);
        }
        return value;
      }
      j1s(descriptor) {
        var index;
        switch (this.o2o_1.w1_1) {
          case 0:
            index = decodeObjectIndex(this, descriptor);
            break;
          case 2:
            index = decodeMapIndex(this);
            break;
          default:
            index = decodeListIndex(this);
            break;
        }
        if (!this.o2o_1.equals(LexerMode_MAP_getInstance())) {
          this.p2o_1.x2o_1.z2u(index);
        }
        return index;
      }
      f1r() {
        return this.p2o_1.v2w();
      }
      g1r() {
        var value = this.p2o_1.w2w();
        if (!(value === fromInt(convertToByte(value)))) {
          this.p2o_1.o2u("Failed to parse byte for input '" + value.toString() + "'");
        }
        return convertToByte(value);
      }
      h1r() {
        var value = this.p2o_1.w2w();
        if (!(value === fromInt(convertToShort(value)))) {
          this.p2o_1.o2u("Failed to parse short for input '" + value.toString() + "'");
        }
        return convertToShort(value);
      }
      i1r() {
        var value = this.p2o_1.w2w();
        if (!(value === fromInt(convertToInt(value)))) {
          this.p2o_1.o2u("Failed to parse int for input '" + value.toString() + "'");
        }
        return convertToInt(value);
      }
      j1r() {
        return this.p2o_1.w2w();
      }
      k1r() {
        var tmp0 = this.p2o_1;
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.parseString' call
          var input = tmp0.a2w();
          try {
            // Inline function 'kotlin.text.toFloat' call
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            tmp$ret$0 = toDouble(input);
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              tmp0.o2u("Failed to parse type '" + 'float' + "' for input '" + input + "'");
            } else {
              throw $p;
            }
          }
        }
        var result = tmp$ret$0;
        var specialFp = this.n2o_1.i2o_1.g2q_1;
        if (specialFp || isFinite(result))
          return result;
        throwInvalidFloatingPointDecoded(this.p2o_1, result);
      }
      l1r() {
        var tmp0 = this.p2o_1;
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.parseString' call
          var input = tmp0.a2w();
          try {
            tmp$ret$0 = toDouble(input);
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              tmp0.o2u("Failed to parse type '" + 'double' + "' for input '" + input + "'");
            } else {
              throw $p;
            }
          }
        }
        var result = tmp$ret$0;
        var specialFp = this.n2o_1.i2o_1.g2q_1;
        if (specialFp || isFinite_0(result))
          return result;
        throwInvalidFloatingPointDecoded(this.p2o_1, result);
      }
      m1r() {
        var string = this.p2o_1.a2w();
        if (!(string.length === 1)) {
          this.p2o_1.o2u("Expected single char, but got '" + string + "'");
        }
        return charCodeAt(string, 0);
      }
      n1r() {
        var tmp;
        if (this.t2o_1.y2p_1) {
          tmp = this.p2o_1.r2w();
        } else {
          tmp = this.p2o_1.z2v();
        }
        return tmp;
      }
      p1r(descriptor) {
        return get_isUnsignedNumber(descriptor) ? new (JsonDecoderForUnsignedTypes())(this.p2o_1, this.n2o_1) : super.p1r(descriptor);
      }
      o1r(enumDescriptor) {
        return getJsonNameIndexOrThrow(enumDescriptor, this.n2o_1, this.n1r(), ' at path ' + this.p2o_1.x2o_1.d2v());
      }
    }
    initMetadataForClass($, 'StreamingJsonDecoder', VOID, VOID, [JsonDecoder()]);
    StreamingJsonDecoderClass = $;
  }
  return StreamingJsonDecoderClass;
}
var JsonDecoderForUnsignedTypesClass;
function JsonDecoderForUnsignedTypes() {
  if (JsonDecoderForUnsignedTypesClass === VOID) {
    class $ extends AbstractDecoder() {
      constructor(lexer, json) {
        super();
        this.x2w_1 = lexer;
        this.y2w_1 = json.h1s();
      }
      h1s() {
        return this.y2w_1;
      }
      j1s(descriptor) {
        // Inline function 'kotlin.error' call
        var message = 'unsupported';
        throw IllegalStateException().o(toString(message));
      }
      i1r() {
        var tmp0 = this.x2w_1;
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.parseString' call
          var input = tmp0.a2w();
          try {
            // Inline function 'kotlin.UInt.toInt' call
            var this_0 = toUInt(input);
            tmp$ret$0 = _UInt___get_data__impl__f0vqqw(this_0);
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              tmp0.o2u("Failed to parse type '" + 'UInt' + "' for input '" + input + "'");
            } else {
              throw $p;
            }
          }
        }
        return tmp$ret$0;
      }
      j1r() {
        var tmp0 = this.x2w_1;
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.parseString' call
          var input = tmp0.a2w();
          try {
            // Inline function 'kotlin.ULong.toLong' call
            var this_0 = toULong(input);
            tmp$ret$0 = _ULong___get_data__impl__fggpzb(this_0);
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              tmp0.o2u("Failed to parse type '" + 'ULong' + "' for input '" + input + "'");
            } else {
              throw $p;
            }
          }
        }
        return tmp$ret$0;
      }
      g1r() {
        var tmp0 = this.x2w_1;
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.parseString' call
          var input = tmp0.a2w();
          try {
            // Inline function 'kotlin.UByte.toByte' call
            var this_0 = toUByte(input);
            tmp$ret$0 = _UByte___get_data__impl__jof9qr(this_0);
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              tmp0.o2u("Failed to parse type '" + 'UByte' + "' for input '" + input + "'");
            } else {
              throw $p;
            }
          }
        }
        return tmp$ret$0;
      }
      h1r() {
        var tmp0 = this.x2w_1;
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.parseString' call
          var input = tmp0.a2w();
          try {
            // Inline function 'kotlin.UShort.toShort' call
            var this_0 = toUShort(input);
            tmp$ret$0 = _UShort___get_data__impl__g0245(this_0);
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              tmp0.o2u("Failed to parse type '" + 'UShort' + "' for input '" + input + "'");
            } else {
              throw $p;
            }
          }
        }
        return tmp$ret$0;
      }
    }
    initMetadataForClass($, 'JsonDecoderForUnsignedTypes');
    JsonDecoderForUnsignedTypesClass = $;
  }
  return JsonDecoderForUnsignedTypesClass;
}
//region block: exports
export {
  JsonDecoderForUnsignedTypes as JsonDecoderForUnsignedTypesaowwj2t4rf8t,
  StreamingJsonDecoder as StreamingJsonDecoderyo05rsghf9i6,
};
//endregion

//# sourceMappingURL=StreamingJsonDecoder.mjs.map
